export const getSession = (state) => state.user

export const getUsuEmail = (state) => state.user.email
export const getUsuPhone = (state) => state.user.phone
export const getUser = (state) => state.user
export const getUserAddress = (state) => state.user.address
